<template>
  <div>
    <!-- <Loader /> -->
    <Toast />
    <div class="main-container">
      <div class="bookinga-logo logo-at-top position-absolute">
        <img src="../assets/logo.png" />
      </div>

      <ul class="navbar">
        <li
          class="sidebar-itemm"
          @mouseover="hover = true"
          @mouseleave="hover = false"
          :class="{ active: hover }"
        >
          <a href="#home">
            <div class="sidebar-link-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1zM6 19h12V9.157l-6-5.454-6 5.454V19zm6-4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                />
              </svg>
            </div>
            <!-- <a href="#home" class="sidebar-link">s-link</a> -->
          </a>
        </li>
        <li class="sidebar-itemm">
          <a href="#about">
            <div class="sidebar-link-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z"
                />
              </svg>
            </div>
            <!-- <a href="#about" class="sidebar-link">s-link</a> -->
          </a>
        </li>
        <li class="sidebar-itemm">
          <a href="#services">
            <div class="sidebar-link-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M3.161 4.469a6.5 6.5 0 0 1 8.84-.328 6.5 6.5 0 0 1 9.178 9.154l-7.765 7.79a2 2 0 0 1-2.719.102l-.11-.101-7.764-7.791a6.5 6.5 0 0 1 .34-8.826zm1.414 1.414a4.5 4.5 0 0 0-.146 6.21l.146.154L12 19.672l5.303-5.304-3.535-3.535-1.06 1.06a3 3 0 1 1-4.244-4.242l2.102-2.103a4.501 4.501 0 0 0-5.837.189l-.154.146zm8.486 2.828a1 1 0 0 1 1.414 0l4.242 4.242.708-.706a4.5 4.5 0 0 0-6.211-6.51l-.153.146-3.182 3.182a1 1 0 0 0-.078 1.327l.078.087a1 1 0 0 0 1.327.078l.087-.078 1.768-1.768z"
                />
              </svg>
            </div>
            <!-- <a href="#services" class="sidebar-link">s-link</a> -->
          </a>
        </li>
        <li class="sidebar-itemm">
          <a href="#contact">
            <div class="sidebar-link-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M21 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8.001 8.001 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 1 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0H21zM7.76 15.785l1.06-1.696A5.972 5.972 0 0 0 12 15a5.972 5.972 0 0 0 3.18-.911l1.06 1.696A7.963 7.963 0 0 1 12 17a7.963 7.963 0 0 1-4.24-1.215z"
                />
              </svg>
            </div>
            <!-- <a href="#contact" class="sidebar-link">s-link</a> -->
          </a>
        </li>
      </ul>

      <div class="home-container d-flex flex-wrap" id="home">
        <div class="welcome">
          <h1 class="bookinga-slogan col-12 ">
            Move with the real ticking of time
          </h1>
          <p class="caption-text">
            "Smart people within a smart nation deserves smart transport sytems.
            It should be made possible for everyone to book bus ticket anywhere
            and anytime with their smart devices. More important everything
            should be simple, Quick and Smart." said Bookinga CEO
          </p>

          <button
            name="bookTicketLink"
            id="book-ticket-link"
            class="btn col-12 col-sm-7"
            @click="login()"
          >
            sign in to book ticket
          </button>
          <div class="last-home-content">
            <p>
              Bookinga is the app for you! You who have to make long lines,
              under the hot sun, or by the splashing raindrops, waiting for an
              unsure arrival of a bus that might delay your plans. It was a
              problem so clear that giving in our will, brains, efforts +water
              bottles was a sure devotion for us. And the idea was born; it
              could not stop growing. .
            </p>
            <strong id="note"
              >"It's yours now to help you have the full control over your
              movements"</strong
            >
          </div>
        </div>
        <div class="illustration-img">
          <img src="../assets/last.png" />
        </div>
      </div>
      <div class="about-with-svgs">
        <div class="about-bookinga" id="about">
          <h4 class="heading-text about-heading text-center">ABOUT BOOKINGA</h4>
          <svg
            class="a-svg"
            xmlns="http://www.w3.org/2000/svg"
            width="246.899"
            height="190.703"
            viewBox="0 0 246.899 190.703"
          >
            <path
              id="Path_2"
              data-name="Path 2"
              d="M10.11,23.221c85.573-46.927,110.11-35.076,123.407,0,2.218,5.847,29.228,29.634,29.228,35.723,0,40.593-54.086,123.407-92.746,123.407s-154.069,8.117-154.069-32.476S-90.564,78.43,10.11,23.221Z"
              transform="translate(84.154 7.689)"
              fill="#a255ec"
            />
          </svg>
          <div class="about-content">
            <p>
              Bookinga is an online platform developed by Zexos Tech Team for
              booking bus tickets beforehand and hiring other kinds of vehicles.
              Bookinga intends to cancel the discomfort caused by waiting lines
              at bus stops and bus stations by benefiting its customers with
              real time booking of journeys beforehand and only come to the
              place just in time to board the bus. Bookinga also works well with
              transportation companies to fully digitalise transportation
              systems This makes it simple for them to manage their clients and
              easy their work
            </p>
          </div>
        </div>
        <svg
          class="b-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="270.418"
          height="187.715"
          viewBox="0 0 270.418 187.715"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M237.262,48.25c61.04-9.743,19.116,46.889,19.116,124.342S139.738,233.361,74.22,233.361,0,222.98,0,145.527,176.221,57.993,237.262,48.25Z"
            transform="translate(0 -47.159)"
            fill="#5344db"
          />
        </svg>
      </div>
      <div class="Bookinga-companies ">
        <div class="companies d-flex flex-wrap">
          <img
            class="company-illustration"
            src="../assets/company.jpg"
            alt=""
          />
          <div class="company-description">
            <h4 class="heading-text">
              Bookinga works with Transportation Companies
            </h4>
            <p>
              Bookinga cann't standalone. Bookinga app works with transportation
              companies. It is stands as an opportunity for company owners to
              continue running their bussiness online even if the offices might
              be closed. Booking also provides company administrators with all
              the company growth statistics that helps them make the right
              decisions toward their company's development.
            </p>
            <h5 class="heading-text">
              You still have an opportunity to register yours!
            </h5>
            <h6 class="heading-text">
              Contact us or send us an email
            </h6>
            <ul class="contacts">
              <li class="contact-us-info">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z"
                  />
                </svg>
                +250786199053
              </li>
              <li class="contact-us-info">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"
                  />
                </svg>
                zexosgroup@gmail.com
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bookinga-services" id="services">
        <h4 class="heading-text services-heading">WHAT BOOKING OFFERS</h4>
        <div class="service-cards-container d-flex flex-wrap">
          <div class="service-card">
            <img class="card-illustration" src="../assets/time.jpg" />
            <h6 class="card-heading">Time management</h6>
            <div class="card-content">
              Time is the most important property that everyone is sitting with.
              Bookinga gives it's customers the ability to have full control
              over their time. With it's aim to help people move with the real
              ticking of time, Time management is achieved with Bookinga app. No
              more wastage of time in tax parks.
            </div>
          </div>
          <div class="service-card">
            <img class="card-illustration" src="../assets/safety.jpg" />
            <h6 class="card-heading">Keeping you safe</h6>
            <div class="card-content">
              Bookinga makes it's customers safe in diffent ways. Firstly, it
              keeps them safe from risks that might result from delaying of the
              bus. Secondly, it prevents them from overcrowding of people in tax
              parks where you might be stolen your properties or contact
              contagious diseases.
            </div>
          </div>
          <div class="service-card">
            <img class="card-illustration" src="../assets/e-pay.jpg" />
            <h6 class="card-heading">Online payment</h6>
            <div class="card-content">
              Bookinga allows its customers to pay tickets online securely. When
              you start using bookinga to book your tickets You will realise
              that you can either pay with your credit card , mobile money
              account or paypay.
            </div>
          </div>
        </div>
      </div>
      <div class="support-info col-12" id="contact">
        <div class="contact-us col-12">
          <div class="support-page">
            <h4 class="heading-text">CONTACT US</h4>
            <p>
              Our support team is always there to hear from our clients. Contact
              us or send us an Email in case you need to tell us anything
            </p>
            <h6 class="division-heading">Contacts</h6>
            <ul class="contacts">
              <li class="contact-us-info">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z"
                  />
                </svg>
                +250786199053
              </li>
              <li class="contact-us-info">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"
                  />
                </svg>
                zexosgroup@gmail.com
              </li>
            </ul>
            <form method="post" class="col-lg-10">
              <h6 class="form-heading">Send us an email</h6>
              <div class="form-group">
                <label for="Email">Email</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  v-model="email"
                  id="email"
                  required
                  placeholder="Enter your email"
                />
              </div>
              <div class="form-group">
                <label for="message">Message</label>
                <textarea
                  class="form-control"
                  name="message"
                  id="message"
                  v-model="question"
                  required
                  rows="3"
                  placeholder="Type your message here"
                ></textarea>
              </div>
              <div>
                <button
                  name="send"
                  id="send"
                  @click.prevent="askQuestion()"
                  class="btn col-12"
                  role="button"
                >
                  Send message
                </button>
              </div>
            </form>
          </div>
          <div class="support-illutration">
            <img src="../assets/contactus.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="divisions col-lg-10 mx-auto d-flex flex-wrap">
          <div class="division1">
            <div class="bookinga-logo position-absolute">
              <img src="../assets/logo.png" />
            </div>
            <div class="app-description">
              <p>
                Bookinga intends to cancel the discomfort caused by waiting
                lines at bus stops and bus stations by benefiting its customers
                with real time booking of journeys beforehand and only come to
                the place just in time to board the bus.
              </p>
            </div>
          </div>

          <div class="division2">
            <h6 class="division-heading">Main links</h6>
            <ul class="footer-items">
              <li class="footer-item1">
                <a
                  @mouseover="hover = true"
                  @mouseleave="hover = false"
                  :class="{ active: hover }"
                  href="#home"
                  class="footer-link"
                  >Home</a
                >
              </li>
              <li class="footer-item1">
                <a href="#about" class="footer-link">About</a>
              </li>
              <li class="footer-item1">
                <a href="#services" class="footer-link">Services</a>
              </li>
              <li class="footer-item1">
                <a href="#contact" class="footer-link">Contact</a>
              </li>
              <li class="footer-item1">
                <a @click="login()" class="footer-link">Login</a>
              </li>
            </ul>
          </div>
          <div class="division4">
            <h6 class="division-heading ">Get in touch</h6>
            <p class="contact-us-info">
              Get in touch with us to enjoy our services
            </p>

            <h6 class="division-heading">Contacts</h6>
            <ul class="contacts">
              <li class="contact-us-info">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z"
                  />
                </svg>
                +250786199053
              </li>
              <li class="contact-us-info">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"
                  />
                </svg>
                zexosgroup@gmail.com
              </li>
            </ul>

            <h6 class="division-heading">Social medias</h6>

            <ul class="footer-items d-flex">
              <li class="footer-item">
                <a href="#" class="footer-link"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      d="M15.402 21v-6.966h2.333l.349-2.708h-2.682V9.598c0-.784.218-1.319 1.342-1.319h1.434V5.857a19.19 19.19 0 0 0-2.09-.107c-2.067 0-3.482 1.262-3.482 3.58v1.996h-2.338v2.708h2.338V21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4.598z"
                      fill="rgba(0,79,129,1)"
                    /></svg
                ></a>
              </li>
              <li class="footer-item">
                <a href="#" class="footer-link"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      d="M22.162 5.656a8.384 8.384 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.21 4.21 0 0 1-1.89.072A4.185 4.185 0 0 0 7.97 16.65a8.394 8.394 0 0 1-6.191 1.732 11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 0 0 2.087-2.165z"
                      fill="rgba(50,152,219,1)"
                    /></svg
                ></a>
              </li>
              <li class="footer-item">
                <a href="#" class="footer-link"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      d="M18.335 18.339H15.67v-4.177c0-.996-.02-2.278-1.39-2.278-1.389 0-1.601 1.084-1.601 2.205v4.25h-2.666V9.75h2.56v1.17h.035c.358-.674 1.228-1.387 2.528-1.387 2.7 0 3.2 1.778 3.2 4.091v4.715zM7.003 8.575a1.546 1.546 0 0 1-1.548-1.549 1.548 1.548 0 1 1 1.547 1.549zm1.336 9.764H5.666V9.75H8.34v8.589zM19.67 3H4.329C3.593 3 3 3.58 3 4.297v15.406C3 20.42 3.594 21 4.328 21h15.338C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3h.003z"
                      fill="rgba(15,75,114,1)"
                    /></svg
                ></a>
              </li>
              <li class="footer-item">
                <a href="https://www.instagram.com/zexosgr/" class="footer-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    height="24"
                    width="24"
                    viewBox="-19.5036 -32.49725 169.0312 194.9835"
                  >
                    <defs>
                      <radialGradient
                        fy="578.088"
                        fx="158.429"
                        gradientTransform="matrix(0 -1.98198 1.8439 0 -1031.399 454.004)"
                        gradientUnits="userSpaceOnUse"
                        xlink:href="#a"
                        r="65"
                        cy="578.088"
                        cx="158.429"
                        id="c"
                      />
                      <radialGradient
                        fy="473.455"
                        fx="147.694"
                        gradientTransform="matrix(.17394 .86872 -3.5818 .71718 1648.351 -458.493)"
                        gradientUnits="userSpaceOnUse"
                        xlink:href="#b"
                        r="65"
                        cy="473.455"
                        cx="147.694"
                        id="d"
                      />
                      <linearGradient id="b">
                        <stop stop-color="#3771c8" offset="0" />
                        <stop offset=".128" stop-color="#3771c8" />
                        <stop stop-opacity="0" stop-color="#60f" offset="1" />
                      </linearGradient>
                      <linearGradient id="a">
                        <stop stop-color="#fd5" offset="0" />
                        <stop stop-color="#fd5" offset=".1" />
                        <stop stop-color="#ff543e" offset=".5" />
                        <stop stop-color="#c837ab" offset="1" />
                      </linearGradient>
                    </defs>
                    <path
                      d="M65.033 0C37.891 0 29.953.028 28.41.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468-4.125 4.282-6.625 9.55-7.53 15.812-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28a27.22 27.22 0 0017.75-14.53c1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624-4.3-4.108-9.56-6.608-15.829-7.512C102.338.157 101.733.027 86.193 0z"
                      fill="url(#c)"
                    />
                    <path
                      d="M65.033 0C37.891 0 29.953.028 28.41.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468-4.125 4.282-6.625 9.55-7.53 15.812-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28a27.22 27.22 0 0017.75-14.53c1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624-4.3-4.108-9.56-6.608-15.829-7.512C102.338.157 101.733.027 86.193 0z"
                      fill="url(#d)"
                    />
                    <path
                      d="M65.003 17c-13.036 0-14.672.057-19.792.29-5.11.234-8.598 1.043-11.65 2.23-3.157 1.226-5.835 2.866-8.503 5.535-2.67 2.668-4.31 5.346-5.54 8.502-1.19 3.053-2 6.542-2.23 11.65C17.06 50.327 17 51.964 17 65s.058 14.667.29 19.787c.235 5.11 1.044 8.598 2.23 11.65 1.227 3.157 2.867 5.835 5.536 8.503 2.667 2.67 5.345 4.314 8.5 5.54 3.054 1.187 6.543 1.996 11.652 2.23 5.12.233 6.755.29 19.79.29 13.037 0 14.668-.057 19.788-.29 5.11-.234 8.602-1.043 11.656-2.23 3.156-1.226 5.83-2.87 8.497-5.54 2.67-2.668 4.31-5.346 5.54-8.502 1.18-3.053 1.99-6.542 2.23-11.65.23-5.12.29-6.752.29-19.788 0-13.036-.06-14.672-.29-19.792-.24-5.11-1.05-8.598-2.23-11.65-1.23-3.157-2.87-5.835-5.54-8.503-2.67-2.67-5.34-4.31-8.5-5.535-3.06-1.187-6.55-1.996-11.66-2.23-5.12-.233-6.75-.29-19.79-.29zm-4.306 8.65c1.278-.002 2.704 0 4.306 0 12.816 0 14.335.046 19.396.276 4.68.214 7.22.996 8.912 1.653 2.24.87 3.837 1.91 5.516 3.59 1.68 1.68 2.72 3.28 3.592 5.52.657 1.69 1.44 4.23 1.653 8.91.23 5.06.28 6.58.28 19.39s-.05 14.33-.28 19.39c-.214 4.68-.996 7.22-1.653 8.91-.87 2.24-1.912 3.835-3.592 5.514-1.68 1.68-3.275 2.72-5.516 3.59-1.69.66-4.232 1.44-8.912 1.654-5.06.23-6.58.28-19.396.28-12.817 0-14.336-.05-19.396-.28-4.68-.216-7.22-.998-8.913-1.655-2.24-.87-3.84-1.91-5.52-3.59-1.68-1.68-2.72-3.276-3.592-5.517-.657-1.69-1.44-4.23-1.653-8.91-.23-5.06-.276-6.58-.276-19.398s.046-14.33.276-19.39c.214-4.68.996-7.22 1.653-8.912.87-2.24 1.912-3.84 3.592-5.52 1.68-1.68 3.28-2.72 5.52-3.592 1.692-.66 4.233-1.44 8.913-1.655 4.428-.2 6.144-.26 15.09-.27zm29.928 7.97a5.76 5.76 0 105.76 5.758c0-3.18-2.58-5.76-5.76-5.76zm-25.622 6.73c-13.613 0-24.65 11.037-24.65 24.65 0 13.613 11.037 24.645 24.65 24.645C78.616 89.645 89.65 78.613 89.65 65S78.615 40.35 65.002 40.35zm0 8.65c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16z"
                      fill="#fff"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-owner-copyright">
          <p>
            All rights reserved zexosgroup@copyright 2021
          </p>
        </div>
        <div class="go-top"></div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router/index";
// import Loader from "./loader.vue";
import Axios from "axios";
const url = "https://bookinga.herokuapp.com/api/v1/question/ask";
export default {
  components: {
    // Loader
  },
  data() {
    return {
      hover: false,
      isLoading: true,
      email: "",
      question: "",
    };
  },
  methods: {
    login() {
      router.push("/login");
    },
    askQuestion() {
      if (this.email != "" && this.question != "") {
        Axios.post(url, {
          email: this.email,
          question: this.question,
        })
          .then((response) => {
            if (response.data.success == true) {
              this.email = "";
              this.question = "";
              return this.$toast.add({
                severity: "success",
                summary: "message received successful!",
                detail:
                  "Our answering team will answer you soon via your email",
                life: 5000,
              });
            } else {
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: response.data.message,
                life: 5000,
              });
            }
          })
          .catch((error) => {
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              detail: error.response.data.message,
              life: 5000,
            });
          });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A message or question should have all the 2 fields",
          life: 5000,
        });
      }
    },
  },
};
</script>

<style scoped>
div.illustration-img > img {
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 90vh;
  z-index: -1;
  position: relative;
  top: -5vh !important;
  width: 100%;
}
div.illustration-img {
  width: 50% !important;
  /* background-color: chocolate;   */
}
.home-container{
  justify-content: space-between;
}

.bookinga-slogan {
  position: relative;
  margin: 2em 0 0.5em;
}

.navbar {
  background-color: #f4f5fe;
  width: 4%;
  position: fixed !important;
  top: 20vh;
  height: fit-content !important;
  padding: 0 !important;
  border-radius: 0 5px 5px 0px;
  z-index: -1;
  display: block;
}

.caption-text {
  font-size: 0.9em !important;
}
.welcome {
  /* background-color: hotpink; */
  width: 40% !important;
  margin: 1em 4em !important;
}
#book-ticket-link {
  color: white !important;
  /* width: 50%; */
  height: 8vh;
  background-color: #5344db;
}
div.main-cantainer {
  /* font-family: "poppins"; */
  font-family: satoshi, "poppins" !important;
  /* align-items: center; */
}
.sidebar-link {
  font-size: 12px !important;
}
.sidebar-itemm {
  padding: 10px;
  z-index: 1 !important;  
}

.active {
  color: #5344db !important;
  text-decoration: underline !important;
}
.sidebar-itemm:hover .sidebar-link {
  color: white !important;
}
.sidebar-itemm:nth-child(1) {
  border-top-right-radius: 5px !important;
}
.sidebar-itemm:last-child {
  border-bottom-right-radius: 5px !important;
}
.last-home-content > p {
  font-size: 16px !important;
  margin-bottom: 0 !important;
}
.last-home-content {
  margin: 2.5em 0em;
  border-radius: 0px 30px;
  padding: 10px !important;
  background-color: #eeeefc;
}
#note {
  font-size: 15px !important;
  font-style: italic;
}
.footer {
  background-color: #f4f5fe;
  /* padding: 10px !important; */
  height: auto;
  /* margin-top: 1em; */
  position: relative;
}
.footer-link > svg {
  box-shadow: 3px 4px 3px #dee2e6;
  margin-right: 1em;
}
footer-item1 > a:hover {
  color: #5748e4;
  text-decoration: underline;
}
.contact-us-info {
  font-size: 16px !important;
}
.content-owner-copyright {
  background-color: #eeeefc;
  padding: 0.5em 0 !important;
  height: 8vh;
  position: relative;
  bottom: 0 !important;
  width: 100% !important;
  margin-top: 1em !important;
}
.content-owner-copyright > p {
  text-align: center;
  line-height: 5vh;
  font-size: 16px !important;
}
.division1 {
  width: 25% !important;
  /* background-color: yellowgreen !important; */
  margin: 1em !important;
  height: fit-content;
  padding: 0em 1em;
}
.app-description {
  margin-top: 5em;
  font-size: 16px !important;
}
.division2 {
  margin-left: 3em;
}
.division2,
.division4 {
  width: 25%;
  margin-top: 25px;
}
.footer-link {
  font-size: 15px !important;
}
.division-heading {
  font-size: 17px;
}
.support-illutration {
  width: 50%;
  /* background-color: blue; */
  padding: 0;
}
.contact-us {
  display: flex;
  flex-wrap: wrap;
}
.support-info {
  margin: 2em 0;
}
.support-page {
  width: 40%;
  margin-left: 4em;
  height: fit-content;
  position: relative;
  top: 4em;
}
.support-page > p {
  font-size: 16px !important;
}
.form-control {
  background-color: #f4f5fe !important;
}
label {
  margin-bottom: 0 !important;
}
#send {
  background-color: #5344db;
  color: white;
  font-size: 12px !important;
  padding: 10px 20px;
}
#send:hover {
  background-color: #5748e4;
}
.form-heading {
  color: #5344db;
}
form {
  padding-left: 0 !important;
}
.card-content {
  font-size: 16px !important;
  padding: 0.5em 1em 3.5em 1.5em !important;
}
.service-card {
  background-color: #ffffff;
  margin: 10px 3%;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 2px #d1d6db;
  width: 27%;
}
.services-heading {
  text-align: center;
}
.about-bookinga,
.bookinga-services {
  margin-left: 4em;
  position: relative;
}

.card-illustration {
  height: 12em;
  width: 100%;
  overflow-y: hidden;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.card-heading {
  font-size: 17px;
  margin: 1em;
  text-align: center;
}
.about-content > p {
  font-size: 16px;
}
.about-content {
  padding: 2em;
  margin: 2em 10px 2em 10px;
  border-radius: 2em 0;
  box-shadow: 0px 0px 10px 0px #e9eff4;
}
.company-illustration {
  width: 50%;
  height: 70vh;
  border-bottom-left-radius: 3em;
  object-fit: cover !important;
}
.Bookinga-companies {
  margin: 4em 0 4em 4em;
}
.company-description {
  width: 50%;
  padding: 1em 3em;
  background-color: rgb(253, 253, 255);
}
.main-container {
  font-family: satoshi, "poppins" !important;
  font-size: 1em;
  font-weight: normal;
}
.a-svg,
.b-svg {
  width: 10% !important;
  position: absolute;
}
.a-svg {
  right: -3.7em !important;
  bottom: 4em;
}
.b-svg {
  top: 7em;
  left: -0.5em;
}
.attachment-svg:nth-child(1) {
  float: right;
  background-color: aqua;
}
.about-with-svgs {
  position: relative;
  width: 85%;
  margin: 0 auto;
}
img,
svg {
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

/* responsiveness */
@media only screen and (max-width: 1024px) {
  .navbar {
    display: none;
  }
  .welcome {
    /* background-color: hotpink; */
    width: 100% !important;
    /* margin: 1em 4em !important;    
     */
    margin: 0 1em !important;
  }
  div.illustration-img > img {
    display: none;
  }
  .about-bookinga,
  .bookinga-services {
    margin: 1em auto;
    position: relative;
  }
  .service-cards-container {
    width: 100%;
    justify-content: center;
  }
  .a-svg,
  .b-svg {
    display: none;
  }
  .about-with-svgs {
    position: relative;
    width: 99%;
    margin: 0 auto;
  }
  .company-illustration {
    width: 100%;
    border-radius: 10px 10px 0 0;
  }
  .Bookinga-companies {
    margin: 1em;
  }
  .company-description {
    width: 100%;
    padding: 1em;
    background-color: rgba(228, 228, 246, 0.589);
    border-radius: 0 0 10px 10px;
  }
  .service-card {
    margin: 1em;
    border-radius: 5px;
    box-shadow: 0px 0px 20px 2px #d1d6db;
    width: 90%;
  }
  .support-info {
    margin: 1em 0;
  }
  .support-page {
    width: 100%;
    margin-left: 0;
    margin-bottom: 5em;
    top: 2em;
  }
  .support-illutration {
    display: none;
  }
  .division1 {
    width: 100% !important;
    margin: 1em !important;
    height: fit-content;
    padding: 1em;
  }

  .division2,
  .division4 {
    margin: 0.75em auto;
    width: 80%;
  }
  .content-owner-copyright {
    position: relative;
  }
  .division-heading {
    font-size: 17px;
  }
}
</style>
